import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import classes from './header.module.css';
import { useAuth } from '../../hooks/useAuth';
import axios from 'axios';
import { FiChevronDown } from 'react-icons/fi';
import { formatUSD } from '../../utils/money';

export default function Header() {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const handleLogout = () => {
        logout();
        navigate('/landing');
    };
    const [coins, setCoins] = useState(user?.coins || 0);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (!user?.id) return;

        const pollData = async () => {
            try {
                const response = await axios.get(`api/users/coins-count`, {
                    params: { user_id: user.id },
                });
                setCoins(response.data.coins);
            } catch (err) {
                console.warn('Failed to refresh coin count:', err.message);
            }
        };

        pollData();
        const intervalId = setInterval(pollData, 5000);
        return () => clearInterval(intervalId);
    }, [user?.id]);

    return (
        <header className={classes.header}>
            <div className={classes.container}>
                <Link to="/" className={classes.logo}>
                    <img src={`/Xbznpd01.svg`} alt={'logo'} />
                </Link>
                {isMobile ? (
                    <div className={classes.mobileMenu}>
                        <Link to="/redeem" className={classes.coinLogo}>
                            <span className={classes.coin_count}>{formatUSD(coins)}</span>
                        </Link>
                        <div className={classes.dropdown}>
                            <button 
                                className={classes.dropdownButton}
                                onClick={() => setIsMenuOpen(!isMenuOpen)}
                            >
                                Menu <FiChevronDown />
                            </button>
                            <div className={`${classes.dropdownContent} ${isMenuOpen ? classes.show : ''}`}>
                                {user && <Link to="/tasks">Explore</Link>}
                                {user && <Link to="/redeem">Redeem</Link>}
                                {user && <Link to="/referrals">Referrals</Link>}
                                {user && <a onClick={handleLogout}>Logout</a>}
                            </div>
                        </div>
                    </div>
                ) : (
                    <nav>
                        <ul>
                            {user && <Link to="/tasks">Explore</Link>}
                            {user && (
                                <li>
                                    <Link to="/redeem" className={classes.redeem}>
                                        Redeem
                                    </Link>
                                </li>
                            )}
                            {user && (
                                <li>
                                    <Link to="/referrals" className={classes.redeem}>
                                        Referrals
                                    </Link>
                                </li>
                            )}
                            {user && (
                                <li>
                                    <Link to="/redeem" className={classes.coinLogo}>
                                        <span className={classes.coin_count}>{formatUSD(coins)}</span>
                                    </Link>
                                </li>
                            )}
                            {user ? (
                                <li className={classes.menu_container}>
                                    <Link to="/tasks">{user.email}</Link>
                                    <div className={classes.menu}>
                                        <a onClick={handleLogout}>Logout</a>
                                    </div>
                                </li>
                            ) : (
                                <Link to="/login" className={classes.loginButton}>Login</Link>
                            )}
                        </ul>
                    </nav>
                )}
            </div>
        </header>
    );
}